import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

type AdminRedirectProps = { children?: JSX.Element };

// BYPASSED FOR LOCAL DEV - No Identity endpoint available
const AdminRedirect: FC<AdminRedirectProps> = ({ children }) => {
    return children || <Outlet />;
};

export default AdminRedirect;
